import { Capacitor } from '@capacitor/core'
import { useMediaQuery } from 'usehooks-ts'

import { breakpoints } from '@/config/layout'

import type { ReactNode } from 'react'

type Props = {
  children: ReactNode | ReactNode[]
}
const NativePlatform = ({ children }: Props) => {
  // check width of the screen to shop mobile or web
  const isMobile = useMediaQuery(breakpoints.toS)
  if (Capacitor.isNativePlatform() || isMobile) {
    return <>{children}</>
  }

  return <>{Capacitor.isNativePlatform() ? children : null}</>
}

const WebPlatform = ({ children }: Props) => {
  // check width of the screen to shop mobile or web
  const isMobile = useMediaQuery(breakpoints.toS)

  if (Capacitor.isNativePlatform() || isMobile) {
    return null
  }

  return <>{Capacitor.isNativePlatform() ? null : children}</>
}

export { NativePlatform, WebPlatform }
